import { render, staticRenderFns } from "./HeartsPage.vue?vue&type=template&id=30289c17&scoped=true&"
import script from "./HeartsPage.vue?vue&type=script&lang=js&"
export * from "./HeartsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30289c17",
  null
  
)

export default component.exports